import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";

import {showErrorMessage} from "@/common/components/ErrorMessage";
import PropTypes from "prop-types";

const base_class = 'm2g-order-confirmation-footer';

const CustomerBalances = ({ViewComponent}) => {
    const [t] = useTranslation('order.balances');
    const [balances, setBalances] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Placeholder functions for testing, to be removed once web api is completed
    // -----------------------------------------------------------------------
    const fetchBalances = async () => {
        return [];
    }
    // -----------------------------------------------------------------------

    useEffect(() => {
        const fetchCustomerBalances = async () => {
            setIsLoading(true);
            try {
                const updatedBalances = await fetchBalances();
                setBalances(updatedBalances);
            } catch (err) {
                throw err;
            } finally {
                setIsLoading(false);
            }
        }

        fetchCustomerBalances()
            .catch(err => {
                showErrorMessage('Error', 'Something went wrong fetching balances')
                console.log(err)
            })
    }, []);

    if (!balances) { // if no balances display nothing
        return null;
    }

    return (
        <>
            {isLoading && (
                <p
                    className={`${base_class}__loading-message`}
                >
                    {t('checking_balances')}
                </p>
            )}
            {balances.map(balance => {
                    return (
                        <ViewComponent
                            key={balance.key}
                            balance={balance}
                        />
                    )
                }
            )}
        </>
    )
}

CustomerBalances.defaultProps = {
    ViewComponent: PropTypes.elementType.isRequired,
}

export default CustomerBalances;
